import { render } from "./search-area.vue?vue&type=template&id=3392388a&bindings={}"
import script from "./search-area.vue?vue&type=script&lang=ts"
export * from "./search-area.vue?vue&type=script&lang=ts"

import "./search-area.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script